const Login = {
  init: function () {
    
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Login.init()
})
